export default __webpack_public_path__ + "static/media/ion_open-outline.2c5d86ca.svg";